<template>
  <div v-if="questionData"
       class="plv-ia-qn-new-question-preview__wrapper"
       :style="{'background-color': showTipPreview ? 'white' : null }"
  >
    <!-- 操作提示-->
    <div v-if="isFirstPreview && !isFullPreview"
         class="plv-ia-qn-new-preview-tip__wrapper"
    >
      <div v-if="index === 1" class="plv-ia-qn-new-preview-tip__content" @click="saveFirstPreview">
        <img src="../images/handle-tip.png" alt=""/>
      </div>
    </div>
    <div class="plv-ia-qn-new-question-preview" :class="{'plv-ia-qn-new-question-preview--disable': isFullPreview}">
      <!-- 操作栏 -->
      <div v-if="!isFullPreview" class="plv-ia-qn-new-preview-handler" :class="{'plv-ia-qn-new-preview-handler--tip': showTipPreview }">
        <div class="plv-ia-qn-new-preview-handler-item" @click.stop="moveUp()">
          <polyv-icon class="plv-ia-qn-new-icon--size16" icon="IconUp" />
        </div>
        <div class="plv-ia-qn-new-preview-handler-item" @click.stop="moveDown()">
          <polyv-icon class="plv-ia-qn-new-icon--size16" icon="IconDown" />
        </div>
        <div class="plv-ia-qn-new-preview-handler-item plv-ia-qn-new-question-bottom-item--delete" @click.stop="deleteQuestion()">
          <polyv-icon class="plv-ia-qn-new-icon--size16" icon="IconDelete" />
        </div>
      </div>
      <div class="plv-ia-qn-new-question-preview-title">
        <p :class="{'plv-ia-qn-new-question-preview--required': questionData.isRequired}">{{ formatTitle }} <span class="plv-ia-qn-new-question-color--blue"> {{ formatScore }}</span></p>
      </div>
      <div v-if="tipLabel" class="plv-ia-qn-new-question-preview-tip"> {{ tipLabel }}</div>
      <div class="plv-ia-qn-new-question-preview-contain">
        <!--  单选题-->
        <template v-if="questionData.type === QUESTION_TYPE.SINGLE || questionData.type === QUESTION_TYPE.JUDGE">
          <div v-for="(item, index) in questionData.options" class="plv-ia-qn-new-question-preview-contain-item" :key="index">
            <div class="plv-ia-qn-new-question-preview-input plv-ia-qn-new-question-preview-radio" :class="{'plv-ia-qn-new-question-preview-radio--checked': isChecked(index)}"></div>
            <div class="plv-ia-qn-new-question-preview-contain-item-label">
              {{ item }}
            </div>
          </div>
        </template>
        <!-- 多选题-->
        <template v-if="questionData.type === QUESTION_TYPE.MULTIPLE">
          <div v-for="(item, index) in questionData.options" class="plv-ia-qn-new-question-preview-contain-item" :key="index">
            <input
              class="plv-ia-qn-new-question-preview-input"
              type="checkbox"
              :checked="isChecked(index)"
              disabled/>
            <div class="plv-ia-qn-new-question-preview-contain-item-label">
              {{ item }}
            </div>
          </div>
        </template>

        <!-- 评分题-->
        <template v-if="questionData.type === QUESTION_TYPE.STAR || questionData.type === QUESTION_TYPE.STAR_NUMBER">
          <div class="plv-ia-qn-new-question-preview-contain-item">
            <template v-if="questionData.type === QUESTION_TYPE.STAR">
              <Star type="star"/>
            </template>
            <template v-if="questionData.type === QUESTION_TYPE.STAR_NUMBER">
              <Star type="number" />
            </template>
          </div>
        </template>

        <!-- 问答题 -->
        <template v-if="questionData.type === QUESTION_TYPE.TEXT">
          <div class="plv-ia-qn-new-question-preview-contain-item">
            <div class="plv-ia-qn-new-question-preview-text-input">
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { QUESTION_TYPE } from '@/assets/app/questionnaire/helper';
import Star from '@/components/star/star';
import Locale from '@/mixins/locale';
import { PolyvIcon } from '@polyv/icons-vue/icon';

export default {
  name: 'QuestionPreview',
  components: {
    Star,
    PolyvIcon
  },
  mixins: [Locale],
  props: {
    questionData: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 1
    },
    // 第一次预览
    isFirstPreview: {
      type: Boolean,
      default: false
    },
    // 是否全屏预览
    isFullPreview: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      QUESTION_TYPE,
    };
  },
  computed: {
    showTipPreview() {
      return this.isFirstPreview && this.index === 1;
    },
    formatTitle() {
      const { index, questionData } = this;
      let typeLabel = '';
      if (questionData.type === QUESTION_TYPE.SINGLE) {
        typeLabel = this.t('plvIA.questionnaire.single');
      } else if (questionData.type === QUESTION_TYPE.MULTIPLE) {
        typeLabel = this.t('plvIA.questionnaire.multiple');
      } else if (questionData.type === QUESTION_TYPE.JUDGE) {
        typeLabel = this.t('plvIA.questionnaire.judgement');
      }
      return `${index}.${typeLabel} ${questionData.name}`;
    },
    tipLabel() {
      const { questionData } = this;
      if (questionData.type === QUESTION_TYPE.MULTIPLE) {
        return '以下答案有多个选项';
      } else if (questionData.type === QUESTION_TYPE.STAR || questionData.type === QUESTION_TYPE.STAR_NUMBER) {
        return questionData.type === QUESTION_TYPE.STAR ? this.t('plvIA.questionnaire.chooseStarTip1') : this.t('plvIA.questionnaire.chooseStarTip2');
      }
      return false;
    },
    formatScore() {
      const { questionData } = this;
      let scoreLabel = '';
      if (questionData.score) {
        scoreLabel = `[${questionData.score}分]`;
      }
      return scoreLabel;
    },
  },
  methods: {
    isChecked(index) {
      const { questionData } = this;
      const item = this.answerCode(index);
      return questionData.answer !== '' && questionData.answer.includes(item);
    },
    answerCode(index) {
      return String.fromCharCode(97 + index);
    },
    saveFirstPreview() {
      this.$emit('change-first-preview', false);
    },
    moveUp() {
      this.$emit('move-up', this.index - 1);
    },
    moveDown() {
      this.$emit('move-down', this.index - 1);
    },
    deleteQuestion() {
      this.$emit('delete-question', this.index - 1);
    },
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-question-preview__wrapper:first-child {
  z-index: 999;
}
.plv-ia-qn-new-preview-tip__wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  .plv-ia-qn-new-preview-tip__content {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    cursor: pointer;
  }
  img {
    position: absolute;
    left: 50%;
    margin-left: -265px;
    bottom: -160px;
    width: 530px;
    height: 260px;
    transform: scale(.6);
  }
}
.plv-ia-qn-new-question-preview__wrapper {
  position: relative;
}
.plv-ia-qn-new-question-preview {
  width: 100%;
  padding: 20px 17px 20px;
  box-sizing: border-box;
  border-top: 1px dashed #e7e7e7;
  cursor: pointer;
  .plv-ia-qn-new-question-preview-text-input {
    border-radius: 4px;
    border: 1px solid #E5E5E5;
    background: #FFFFFF;
    height: 40px;
    width: 100%;
    max-width: 400px;
  }
}
.plv-ia-qn-new-question-preview:hover {
  background-color: #F6F6F6;
  .plv-ia-qn-new-preview-handler {
    display: block;
    z-index: 10;
  }
}
.plv-ia-qn-new-question-preview-title {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.plv-ia-qn-new-question-preview-contain-item {
  display: flex;
  margin-top: 16px;
  input[type=checkbox]::after {
    width: 16px !important;
    height: 16px !important;
  }
  .plv-ia-qn-new-question-preview-input {
    width: 16px !important;
    height: 16px !important;
    background: #FFFFFF;
    margin-right: 10px;
    box-sizing: border-box;
  }
  .plv-ia-qn-new-question-preview-radio {
    border: 1px solid #CFD8DC;
    border-radius: 50%;
  }
  .plv-ia-qn-new-question-preview-radio--checked {
    border: 4px solid var(--interactBlue);
  }
}
.plv-ia-qn-new-question-preview-tip {
  margin-top: 12px;
  color: #757575;
  font-size: 12px;
}
.plv-ia-qn-new-preview-handler--tip {
  display: block !important;
}
.plv-ia-qn-new-preview-handler {
  position: absolute;
  right: 16px;
  top: 10px;
  display: none;
  .plv-ia-qn-new-preview-handler-item {
    width: 24px;
    height: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 7px;
    box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 10%);
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.plv-ia-qn-new-question-preview--required {
  position: relative;
  margin-left: 8px;
  padding-right: 30px;
  word-break: break-all;
}
.plv-ia-qn-new-question-preview--disable:hover {
  background-color: inherit !important;
  cursor: unset;
}
.plv-ia-qn-new-question-preview--required:before {
  content: '*';
  position: absolute;
  color: #FF4646;
  left: -7px;
  top: 0;
}
.plv-ia-qn-new-preview-handler-item:hover {
  svg {
    path {
      fill: var(--interactBlue);
    }
  }
}
.plv-ia-qn-new-question-bottom-item--delete:hover {
  color: #FC1212 !important;
  cursor: pointer;
  svg {
    path {
      fill: #FC1212 !important;
    }
  }
}
.plv-ia-qn-new-question-preview-contain-item-label {
  flex: 1;
  word-break: break-all;
  padding-right: 30px;
}
</style>
